import React, { useEffect, useState } from 'react';
import ComponentCard from './RiskComponentCard';
import OperationCard from './OperationCard';
import { CardStyle, Entityflex1, Entityflex2, Entityflex3, InputTextField } from './FilterStyle';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CheckboxValueCard from './CheckboxValueCard';
import TypeComponent from './TypeComponent';
import ScoreComponent from './ScoreComponent';
import { pushValueString, pushSelectedChipArray, pushCheckboxData } from '../../slices/RiskFilterSlice';
import { getApiResponseData } from '../../services/apiservices';
import SearchHeader from './SearchHeader';
import { pushCheckBoxShowLoading, pushCheckBoxHideLoading } from '../../slices/SpinnerSlice';
import { getFilterUrl } from '../../utils/utils';

const FilterBody = () => {
  const [updatedpage, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchUpdatedpage, setSearchPage] = React.useState(0);
  const [searchRowsPerPage, setSearchRowsPerPage] = React.useState(10);
  const dispatch = useDispatch();
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const filterQueryArray = useSelector(state => state.riskFilterSlice.filterQueryArray);
  const filterQueryArrayValue = useSelector(state => state.riskFilterSlice.filterQueryArray[0]);
  const paginationData = useSelector(state => state.recommendationTable.paginationData);
  const filterQueryArrayValue1 = useSelector(state => state.riskFilterSlice.filterQueryArray[1]);
  const selectedType = useSelector(state => state.riskFilterSlice.type);
  const checkBoxData = useSelector(state => state.riskFilterSlice.checkBoxData);
  const accordionKeyItems = useSelector(state => state.componentCardSlice.buttonsNamesArray);
  const envAccordionKeyItems = useSelector(state => state.componentCardSlice.environmentAccordion);
  const isAccordionOpen = useSelector(state => state.riskFilterSlice.isAccordionOpen);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const [inputText, setInputText] = useState('');

  const onChangeTextInput = event => {
    var value = event.target.value;
    setInputText(value);
  };

  useEffect(() => {
    dispatch(pushCheckBoxShowLoading(true));

    if (selectedType && selectedType.keyName && selectedType.keyName.length && !selectedType.keyName.includes('Risk') && selectedType.recordType === 'is') {
      let searchType = '';

      switch (selectedType.keyName) {
        case 'Application Name':
          {
            searchType = 'appName';
            break;
          }

        case 'Application Type':
          {
            searchType = 'appType';
            break;
          }

        case 'Environment Name':
          {
            searchType = 'envName';
            break;
          }

        case 'Entity Name':
          {
            searchType = 'objectName';
            break;
          }

        case 'Entity Type':
          {
            searchType = 'objectType';
            break;
          }

        default:
          break;
      }

      let obj = {
        searchType,
        limit: rowsPerPage,
        offsetValue: updatedpage
      };

      if (clickEvent) {
        obj.filterValue = `origin=${selectedApplication},recoType=any`;
      }

      let url = getFilterUrl(obj);
      dispatch(getApiResponseData(url, 'paginationData'));
    }
  }, [rowsPerPage, updatedpage, selectedType]);
  useEffect(() => {
    if (paginationData?.data?.responseList?.length) {
      let updatedData = paginationData.data.responseList;
      dispatch(pushCheckboxData(updatedData));
      dispatch(pushCheckBoxHideLoading(false));
    }
  }, [paginationData]);
  useEffect(() => {
    if (filterQueryArray.length > 0) {
      if (inputText) {
        let chipArray = [];
        chipArray.push(filterQueryArray[0] + ' ' + filterQueryArray[1] + ' ' + inputText);
        dispatch(pushValueString(inputText));
        dispatch(pushSelectedChipArray(chipArray));
      } else {
        dispatch(pushValueString(inputText));
        dispatch(pushSelectedChipArray([]));
      }
    }
  }, [inputText]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showCard ? /*#__PURE__*/React.createElement(CardStyle, null, /*#__PURE__*/React.createElement(Entityflex1, null, clickEvent ? /*#__PURE__*/React.createElement(ComponentCard, {
    accordionKeyItems: envAccordionKeyItems,
    setRowsPerPage: setRowsPerPage
  }) : /*#__PURE__*/React.createElement(ComponentCard, {
    accordionKeyItems: accordionKeyItems,
    setRowsPerPage: setRowsPerPage
  })), /*#__PURE__*/React.createElement(Entityflex2, null, filterQueryArray && filterQueryArray.length && isAccordionOpen ? /*#__PURE__*/React.createElement(OperationCard, {
    setInputText: setInputText
  }) : null), /*#__PURE__*/React.createElement(Entityflex3, null, isAccordionOpen && filterQueryArray.length >= 2 ? filterQueryArrayValue.includes('Risk Score') && filterQueryArray.length > 1 ? /*#__PURE__*/React.createElement(ScoreComponent, null) : filterQueryArrayValue1 === 'is' && filterQueryArray.length > 1 ? filterQueryArrayValue.includes('Risk Category') ? /*#__PURE__*/React.createElement(TypeComponent, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchHeader, {
    type: selectedType,
    searchUpdatedpage: searchUpdatedpage,
    searchRowsPerPage: searchRowsPerPage
  }), /*#__PURE__*/React.createElement(CheckboxValueCard, {
    filterValueCardData: checkBoxData,
    type: selectedType,
    paginationData: paginationData,
    setPage: setPage,
    setRowsPerPage: setRowsPerPage,
    rowsPerPage: rowsPerPage,
    searchUpdatedpage: searchUpdatedpage,
    searchRowsPerPage: searchRowsPerPage,
    setSearchPage: setSearchPage,
    setSearchRowsPerPage: setSearchRowsPerPage
  })) : /*#__PURE__*/React.createElement(InputTextField, {
    type: "text",
    value: inputText,
    placeholder: "Enter",
    onChange: onChangeTextInput,
    variant: "outlined"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null))) : null);
};

export default withRouter(FilterBody);